var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExplain = function SvgExplain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#explain_svg__a)",
    filter: "url(#explain_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.034 15h2v2h-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794L8.6 9.313a3.5 3.5 0 1 1 4.433 4.042m2-9.355h-10v16h14V8h-4zm-12-1.008c0-.548.447-.992.999-.992h12l5 5v13.993A1 1 0 0 1 20.042 22H4.027a1 1 0 0 1-.993-.992z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M10.534 15v-2.5a1.5 1.5 0 0 1 1.5-1.5zm0 0v2.5h3v-3m-3 .5 3-.5m0 0v-.791A4 4 0 0 0 15.743 8.5m-2.21 6 2.21-6m0 0h2.79v11h-13v-15h9v2.376m1.21 1.624-1.21-1.624m0 0A4 4 0 0 0 8.11 9.215l-.098.49.49.098 1.962.393.491.098.098-.49a1 1 0 1 1 .98 1.196zm1.854-5.23-.146-.146 4.793 19.493h.5v-14.2l-.147-.147z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "explain_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.034 0h24v24h-24z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "explain_svg__b",
    width: 20,
    height: 22.361,
    x: 2.034,
    y: 1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12286_6572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_12286_6572",
    result: "shape"
  })))));
};
export default SvgExplain;